/* eslint-disable quotes */
type Littlewoods = {
  [key: string]: string;
};

export default {
  'littlewoods.card.stcNoOptionSelected.description':
    'Choose from the product options below to see your interest free weekly pricing.',
  'littlewoods.card.stc.description': 'You can pay for this item with <strong>{0} weekly payments of £{1} </strong>',
  'littlewoods.card.bnpl.description': 'Available on this item.',
  'littlewoods.card.stcNoOptionSelected.heading': 'Spread the cost, Interest Free!',
  'littlewoods.card.stc.heading': 'Spread the cost, interest free!',
  'littlewoods.card.bnpl.heading': 'Buy Now Pay Later',
  'littlewoods.card.link.text': 'More info and other options',
} as Littlewoods;
